import { useState } from 'react';

type ConfirmModalType = 'confirmed' | 'opened' | 'closed';

type useConfirmModalProps = {
	onConfirmed: () => void;
	onCanceled: () => void;
};

export const useConfirmModal = ({
	onConfirmed,
	onCanceled,
}: useConfirmModalProps) => {
	const [state, setState] = useState<ConfirmModalType>('closed');

	const handleModalConfirm = () => {
		setState('confirmed');
		return onConfirmed();
	};

	const handleModalCancel = () => {
		if (state !== 'confirmed') {
			onCanceled();
		}
		setState('closed');
	};

	return {
		isConfirmModalOpen: state === 'opened',
		showConfirmModal: () => setState('opened'),
		handleModalConfirm,
		handleModalCancel,
	};
};
